import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { resourceFromAttributes } from "@opentelemetry/resources";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from "@opentelemetry/semantic-conventions";
import { SpanStatusCode, trace } from "@opentelemetry/api";

const otlpEndpoint = import.meta.env.VITE_SIGNOZ_OTLP_ENDPOINT ?? "http://localhost:4318";
const otlpToken = import.meta.env.VITE_SIGNOZ_OTLP_TOKEN;

const exporterHeaders = otlpToken ? { Authorization: `Bearer ${otlpToken}` } : {};

const provider = new WebTracerProvider({
  resource: resourceFromAttributes({
    [ATTR_SERVICE_NAME]: "smarttitan-frontend",
    [ATTR_SERVICE_VERSION]: import.meta.env.VITE_APP_VERSION ?? "2.0.0",
  }),
  spanProcessors: [
    new BatchSpanProcessor(
      new OTLPTraceExporter({
        url: `${otlpEndpoint}/v1/traces`,
        headers: exporterHeaders,
      })
    ),
  ],
});

provider.register();

const tracer = trace.getTracer("smarttitan-frontend");

export function recordError(error, context = {}) {
  const err = error instanceof Error ? error : new Error(String(error));
  const span = tracer.startSpan("frontend.error");
  span.recordException(err);
  span.setStatus({ code: SpanStatusCode.ERROR, message: err.message });
  Object.entries(context).forEach(([k, v]) => span.setAttribute(k, String(v)));
  span.end();
  // Match backend structured logging convention
  console.error(err.message, context);
}

export function recordVital({ name, value, rating }) {
  const span = tracer.startSpan(`web_vital.${name}`);
  span.setAttribute("web_vital.name", name);
  span.setAttribute("web_vital.value", value);
  span.setAttribute("web_vital.rating", rating);
  span.end();
}

window.addEventListener("error", (event) => {
  recordError(event.error ?? new Error(event.message), {
    "error.type": "uncaught",
    "error.source": event.filename,
    "error.line": event.lineno,
    "error.col": event.colno,
  });
});

window.addEventListener("unhandledrejection", (event) => {
  const err = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
  recordError(err, { "error.type": "unhandledrejection" });
});
